import { PaymentLinkDetails, CreateUpdatePaymentLinkFormValues } from "../paymentLinksTypes"
import { DateTimeFactory } from "../../../../localization/useDateTime"

export const prepareInitialValues = (
    dateTimeFactory: DateTimeFactory,
    result?: PaymentLinkDetails,
): CreateUpdatePaymentLinkFormValues => {
    return {
        title: result?.title ?? "",
        description: result?.description ?? "",
        isActive: result?.isActive ?? true,
        security: result?.security ?? {
            hasPasswordProtection: true,
            password: "",
        },
        shop: result?.shop ?? { id: "" },
        salesAccount: result?.salesAccount ?? { id: "" },
        availabilityDetails: result?.availabilityDetails
            ? {
                  dateInterval: {
                      from: result.availabilityDetails?.dateInterval?.from
                          ? dateTimeFactory.fromISO(result.availabilityDetails?.dateInterval?.from)
                          : null,
                      to: result.availabilityDetails?.dateInterval?.to
                          ? dateTimeFactory.fromISO(result.availabilityDetails?.dateInterval?.to)
                          : null,
                  },
              }
            : {},
    }
}
